module.exports = alasql;


//////////////////
// WEBPACK FOOTER
// external "alasql"
// module id = 119
// module chunks = 0